module.exports = __webpack_public_path__ + "img/a-class.408ec108.jpg";